import { ReactElement, useMemo } from 'react';

import { Dropdown } from '@dreryk/react-components';
import { Translate, useBoolean } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

import { AppointmentNoteManagementModal } from './AppointmentNoteManagementModal';

type UseAppointmentNoteCreateDropdownItemOptions = {
   appointmentId: number;
   onAppointmentNoteAdded: VoidFunction;
};

type UseAppointmentNoteCreateDropdownItemOutput = {
   AppointmentNoteCreateDropdownItem: () => ReactElement;
   appointmentNoteCreateModal: ReactElement;
};

export const useAppointmentNoteCreateDropdownItem = (
   options: UseAppointmentNoteCreateDropdownItemOptions
): UseAppointmentNoteCreateDropdownItemOutput => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   const handleSuccess = (): void => {
      options.onAppointmentNoteAdded();
      closeModal();
   };

   return useMemo(
      () => ({
         AppointmentNoteCreateDropdownItem: () => (
            <Dropdown.Item
               testId={`appointmentNoteCreate${options.appointmentId}`}
               onClick={(hide) => {
                  openModal();
                  hide();
               }}
            >
               <Translate>{translationKeys.noteManagement.create.label}</Translate>
            </Dropdown.Item>
         ),
         appointmentNoteCreateModal: (
            <>
               {modalOpened ? (
                  <AppointmentNoteManagementModal
                     appointmentId={options.appointmentId}
                     onSuccess={handleSuccess}
                     onClose={closeModal}
                  />
               ) : null}
            </>
         ),
      }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [modalOpened, openModal, closeModal, options.appointmentId, options.onAppointmentNoteAdded]
   );
};
